import sendRequest from "@/libs/sendRequest";

export const bonificaciones = {
    namespaced: true,

    state: {
        data: [],
        total_data: 0,
        loading: false,
        error: null,
        adding: false,
        current_page: 1,
        page_limit: 10,

        // Agregado para rutas y clientes
        rutas: {
            data: [],
            loading: false,
            error: null
        },
        clients: {
            data: [],
            total: 0,
            loading: false,
            error: null
        }
    },

    getters: {
        getItems: (state) => state.data,
        getTotal: (state) => state.total_data,
        isLoading: (state) => state.loading,
        isAdding: (state) => state.adding,
        getError: (state) => state.error,
        getCurrentPage: (state) => state.current_page,
        getPageLimit: (state) => state.page_limit,

        // Getters para rutas y clients
        getRutas: (state) => state.rutas.data,
        isRutasLoading: (state) => state.rutas.loading,
        getRutasError: (state) => state.rutas.error,

        getClients: (state) => state.clients.data,
        getClientsTotal: (state) => state.clients.total,
        isClientsLoading: (state) => state.clients.loading,
        getClientsError: (state) => state.clients.error
    },

    mutations: {
        setItems: (state, payload) => { state.data = payload; },
        setTotalItems: (state, payload) => { state.total_data = payload; },
        setLoading: (state, payload) => { state.loading = payload; },
        setAdding: (state, payload) => { state.adding = payload; },
        setError: (state, payload) => { state.error = payload; },
        clearError: (state) => { state.error = null; },
        setCurrentPage: (state, payload) => { state.current_page = payload; },

        // Mutations para rutas
        SET_RUTAS: (state, payload) => { state.rutas.data = payload; },
        SET_RUTAS_LOADING: (state, payload) => { state.rutas.loading = payload; },
        SET_RUTAS_ERROR: (state, payload) => { state.rutas.error = payload; },

        // Mutations para clients
        SET_CLIENTS: (state, payload) => { state.clients.data = payload; },
        SET_CLIENTS_TOTAL: (state, payload) => { state.clients.total = payload; },
        SET_CLIENTS_LOADING: (state, payload) => { state.clients.loading = payload; },
        SET_CLIENTS_ERROR: (state, payload) => { state.clients.error = payload; },
    },

    actions: {
        async list({ commit, state, rootGetters }, params = {}) {
            const page = params.page ?? state.current_page;
            const rows = params.rows ?? state.page_limit;
            const search = params.search ?? '';
            const order_by = params.order_by ?? 'Id';
            const order_asc = params.order_asc ?? true;
            const showLoader = params.showLoader ?? true;

            if (showLoader) {
                commit('setLoading', { show: true }, { root: true });
            }
            commit('clearError');

            try {
                const response = await sendRequest(
                    `administrator/heishop/promociones-precios/list?isDatatable=true&page=${page}&rows=${rows}&search=${search}&order_by=${order_by}&order_asc=${order_asc}`,
                    'GET',
                    null,
                    null,
                    null,
                    rootGetters.getHeaders
                );

                if (response.data?.list?.result) {
                    commit('setItems', response.data.list.result);
                    commit('setTotalItems', response.data.list.total_rows);
                    commit('setCurrentPage', page);
                    return {
                        success: true,
                        data: response.data
                    };
                } else {
                    const error = {
                        code: 'data_error',
                        message: 'Error al procesar los datos recibidos',
                        details: response.errors
                    };
                    commit('setError', error);
                    commit('setAlert', {
                        open: true,
                        variant: 'danger',
                        message: error.message
                    }, { root: true });

                    return {
                        success: false,
                        error
                    };
                }

            } catch (error) {
                const normalizedError = {
                    code: 'network_error',
                    message: 'Error de conexión al cargar los precios de bonificación',
                    details: error.message || error
                };
                commit('setError', normalizedError);
                commit('setAlert', {
                    open: true,
                    variant: 'danger',
                    message: normalizedError.message
                }, { root: true });

                return {
                    success: false,
                    error: normalizedError
                };
            } finally {
                if (showLoader) {
                    commit('setLoading', { show: false }, { root: true });
                }
            }
        },

        add: async ({ commit, rootGetters }, { data }) => {
              const custom_headers = rootGetters.getHeaders;
              commit('clearError');
            
              try {
                if (!data || Object.keys(data).length === 0) {
                  const error = {
                    code: 'invalid_data',
                    message: 'Datos incompletos o vacíos para enviar los precios.',
                    details: data
                  };
                  commit('setError', error);
                  commit('setAlert', {
                    open: true,
                    variant: 'danger',
                    message: error.message
                  }, { root: true });
                  return { success: false, error };
                }
            
                const response = await sendRequest(
                  `administrator/heishop/promociones-precios/add`,
                  'POST',
                  null,
                  data,
                  null,
                  custom_headers
                );
            
                if (response.success) {
                  commit('setAlert', {
                    open: true,
                    variant: 'success',
                    message: 'Registro guardado correctamente.'
                  }, { root: true });

                  return {
                    success: true,
                    data: response.data,
                    message: 'Registro guardado correctamente.'
                  };
                } else {
                  const responseError = Array.isArray(response.errors)
                    ? response.errors[0]
                    : Object.values(response.errors ?? {})[0];
                  const error = {
                    code: responseError?.code || 'api_error',
                    message: responseError?.message || responseError?.detail || responseError?.code || 'Error desconocido del servidor',
                    httpStatus: response.http,
                    details: response.errors
                  };
                  commit('setError', error);
                  commit('setAlert', {
                    open: true,
                    variant: 'danger',
                    message: error.message
                  }, { root: true });
                  return { success: false, error };
                }
            
              } catch (error) {
                const normalizedError = {
                  code: error.code || 'network_error',
                  message: error.message || 'Error de red al enviar precios',
                  details: error.details || error
                };
                commit('setError', normalizedError);
                commit('setAlert', {
                  open: true,
                  variant: 'danger',
                  message: normalizedError.message
                }, { root: true });
                return { success: false, error: normalizedError };
              }
        },    
        

        async changePage({ commit, dispatch }, page) {
            commit('setCurrentPage', page);
            await dispatch('list', { page });
        },

        // NUEVAS ACCIONES:

        // fetchRutas
        async fetchRutas({ commit, rootGetters }) {
            commit('SET_RUTAS_LOADING', true);
            commit('SET_RUTAS_ERROR', null);

            try {
                const response = await sendRequest(
                    `administrator/heishop/rutas`,
                    'GET',
                    null,
                    null,
                    null,
                    rootGetters.getHeaders
                );

                if (!response?.data?.rutas) {
                    throw new Error('Formato de respuesta inesperado');
                }

                const rutasMapped = Array.isArray(response.data.rutas)
                    ? response.data.rutas
                        .filter(ruta => ruta.ruta?.toLowerCase().startsWith('p'))
                        .map(ruta => ({
                            value: ruta.ruta || '',
                            label: ruta.ruta || 'Ruta sin nombre',
                            rawData: ruta,
                        }))
                    : [];

                commit('SET_RUTAS', rutasMapped);
                return rutasMapped;
            } catch (error) {
                commit('SET_RUTAS_ERROR', error.message || 'Error al cargar rutas');
                throw error;
            } finally {
                commit('SET_RUTAS_LOADING', false);
            }
        },

        // fetchClients
        async fetchClients({ commit, rootGetters }, { ruta = '' } = {}) {
            commit('SET_CLIENTS_LOADING', true);
            commit('SET_CLIENTS_ERROR', null);

            try {
                let url = 'administrator/heishop/clientes/list';

                if (ruta) {
                    url += `?ruta=${encodeURIComponent(ruta)}`;
                }

                const response = await sendRequest(
                    url,
                    'GET',
                    null,
                    null,
                    null,
                    rootGetters.getHeaders
                );

                if (
                    !response?.data ||
                    !response.data.list ||
                    !Array.isArray(response.data.list)
                ) {
                    throw new Error(response?.errors?.[0]?.message || 'Estructura de respuesta inválida');
                }

                const clientsMapped = response.data.list.map(client => ({
                    value: client.ClaveFerguez || '',
                    label: client.ClaveFerguez || 'Cliente sin clave',
                    rawData: client,
                }));

                commit('SET_CLIENTS', clientsMapped);
                commit('SET_CLIENTS_TOTAL', response.data.list.total_rows || 0);

                return clientsMapped;
            } catch (error) {
                commit('SET_CLIENTS_ERROR', error.message || 'Error al cargar clientes');
                throw error;
            } finally {
                commit('SET_CLIENTS_LOADING', false);
            }
        }
    }
};
